import { Component, OnInit } from '@angular/core';
import { PhotoEditorCanvasService } from '../../photo-editor-canvas/photo-editor-canvas.service';
import { FormGroup, FormControl } from '@angular/forms';
import { PhotoEditorToolsFontSelectService } from './photo-editor-tools-font-select.service';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-photo-editor-tools-font-select',
  templateUrl: './photo-editor-tools-font-select.component.html',
  styleUrls: ['./photo-editor-tools-font-select.component.scss']
})
export class PhotoEditorToolsFontSelectComponent implements OnInit {

  showSelectFont: boolean;
  fontForm = new FormGroup({
    font: new FormControl()
  });
  fonts = [
    {
      id: 'OpenSans',
      name: 'Sans serif',
      family: '"Open Sans", sans-serif'
    },
    {
      id: 'PTSerif',
      name: 'Serif',
      family: '"PT Serif", serif'
    },
    {
      id: 'Pacifico',
      name: 'Pacifico',
      family: '"Pacifico", cursive'
    },
    {
      id: 'FredokaOne',
      name: 'Display',
      family: '"Fredoka One", cursive'
    },
    {
      id: 'PTMono',
      name: 'Monospace',
      family: '"PT Mono", monospace'
    },
    {
      id: 'Roboto',
      name: 'Roboto',
      family: '"Roboto", sans-serif'
    },
    {
      id: 'Nunito',
      name: 'Nunito',
      family: '"Nunito", sans-serif'
    },
    {
      id: 'Caveat',
      name: 'Caveat',
      family: '"Caveat", cursive'
    },
    {
      id: 'Alfa Slab One',
      name: 'Alfa Slab One',
      family: '"Alfa Slab One", cursive'
    },
    {
      id: 'Archivo Black',
      name: 'Archivo Black',
      family: '"Archivo Black", sans-serif'
    },
    {
      id: 'Ballet',
      name: 'Ballet',
      family: '"Ballet", cursive'
    },
    {
      id: 'Bangers',
      name: 'Bangers',
      family: '"Bangers", cursive'
    },
    {
      id: 'Titillium',
      name: 'Titillium',
      family: '"Titillium Web", sans-serif'
    },
    {
      id: 'Anton',
      name: 'Anton',
      family: '"Anton", sans-serif'
    },
    {
      id: 'Gloria Hallelujah',
      name: 'Gloria Hallelujah',
      family: '"Gloria Hallelujah", cursive'
    },
    {
      id: 'Prata',
      name: 'Prata',
      family: '"Prata", serif'
    },
    {
      id: 'News Cycle',
      name: 'News Cycle',
      family: '"News Cycle", sans-serif'
    },
    {
      id: 'Baloo 2',
      name: 'Baloo 2',
      family: '"Baloo 2", cursive'
    }
  ];
  constructor(private photoEditorToolsFontSelectService: PhotoEditorToolsFontSelectService) { }

  ngOnInit() {
    this._listenSetFontListener();
    this._listenShowFontSelectListener();
    this._listenHideFontSelectListener();
  }

  public setFont(font) {
    this.photoEditorToolsFontSelectService.selectFont(font ? font : this.fontForm.get('font').value);
  }

  private _findElementFont(element) {
    const fonts = this.fonts.filter(f => f.family === element.style.fontFamily);
    return fonts[0];
  }

  private _updateForm(font) {
    this.fontForm.patchValue({
      font: font
    });
  }

  private _listenSetFontListener() {
    this.photoEditorToolsFontSelectService.listenSelectFont().pipe(
      tap(res => this._updateForm(res))
    ).subscribe();
  }

  private _listenShowFontSelectListener() {
    this.photoEditorToolsFontSelectService.listenShowFontSelect().pipe(
      tap(res => !this.showSelectFont ? this.showSelectFont = true : null),
      tap(res => this.setFont(this._findElementFont(res)))
    ).subscribe();
  }

  private _listenHideFontSelectListener() {
    this.photoEditorToolsFontSelectService.listenHideFontSelect().pipe(
      tap(res => this.showSelectFont ? this.showSelectFont = false : null)
    ).subscribe();
  }

  public setSelected(c1, c2): boolean {
      return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }
}
